import CloseIcon from '@mui/icons-material/Close';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import {Box, Button, Divider, IconButton, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import EventExportFieldForm from '../common/EventExportFieldForm';
import ExportPdfButton from '../common/ExportPdfButton';
import ModalFixed from '../common/ModalFixed';
import {EventsReportData} from '../dashboard-panels/ConnectView/EventsReport';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  value?: EventsReportData;
  onSubmitted?: () => void;
}

const EventExportButton = <T extends ComponentType>({
  component,
  componentProps,
  children,
  value,
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);
  const [isCsvModalOpened, setIsCsvModalOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <Component {...componentProps} onClick={() => setIsOpened(true)}>
          {children}
        </Component>
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <ImportExportIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export Events</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <Box display="flex" flexDirection="column" gap={2}>
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  onClick={() => setIsCsvModalOpened(true)}
                >
                  Export to CSV
                </Button>
              </Box>
              <ExportPdfButton
                endpoint="/event"
                defaultFilename="events.pdf"
                params={value?.params}
                exportFields={value?.exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}

      <ModalFixed
        open={isCsvModalOpened}
        onClose={() => setIsCsvModalOpened(false)}
      >
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <EventExportFieldForm
            value={value}
            exportFields={value?.exportFields}
            columns={1}
          />
        </Box>
      </ModalFixed>
    </>
  );
};

export default EventExportButton;
